import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import SellingService from "../services/SellingService";
import WarehouseService from "../services/WarehouseService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import toastr from "toastr";

const UpdatePrixModal = ({ show, onClose, product, idWarehouse, idUser, refrech, setRefrech,devise,nameWarehouse }) => {
  const [quantite, setQuantite] = useState(0);
  useEffect(()=>{
    setQuantite(product?.initial_selling_price)
  }, [product])
  const handleSave = async () => {
    

    try {
      const data = {
        "idProduct": product?.product.id,
        "idUser": idUser,
        "productWarehousePrices": [
          {
            "devise": devise || "",
            "value": quantite,
            "warehouseId": idWarehouse,
            "warehouseName": nameWarehouse
          }
        ]
      }
      await SellingService.setSellingPrice(data);
      toastr.success(`Le Prix de vente mis à jour avec succès !`);
      onClose();
      setRefrech(!refrech)
    } catch (error) {
      console.error("Erreur lors de la mise à jour du stock :", error);
    //   alert("Échec de la mise à jour du stock.");
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Modifier le Prix de vente  </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <strong>Code barre du produit : {product?.product?.barcode}</strong>
        <Form.Group>
          <Form.Label>Nouveau Prix de vente</Form.Label>
          <Form.Control
            type="number"
            value={quantite}
            step="0.01"
            onChange={(e) => setQuantite(parseFloat(e.target.value) || 0)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={()=>{
          onClose()
       
        }}>
          Annuler
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Enregistrer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdatePrixModal;
